module.exports = __webpack_public_path__ + "img/human-resources-bg-icon.e9f4806f.png";